export default __webpack_public_path__ + "static/media/logo.0f4629ae.svg";